module.exports = __webpack_public_path__ + "static/media/estilosos_masculino_ate_300.fe1e4904.jpg";